module.exports = __webpack_public_path__ + "img/documents.9b446fe6.svg";